import { index, pgTable, varchar } from 'drizzle-orm/pg-core';
import { usersTable } from '#/db/schema/users';
import { nanoid } from '#/utils/nanoid';
import { timestampsColumn } from '../utils/timestamp-columns';
import { organizationsTable } from './organizations';

export const workspacesTable = pgTable(
  'workspaces',
  {
    id: varchar().primaryKey().$defaultFn(nanoid),
    entity: varchar({ enum: ['workspace'] })
      .notNull()
      .default('workspace'),
    name: varchar().notNull(),
    slug: varchar().unique().notNull(),
    organizationId: varchar()
      .notNull()
      .references(() => organizationsTable.id, {
        onDelete: 'cascade',
      }),
    thumbnailUrl: varchar(),
    bannerUrl: varchar(),
    createdAt: timestampsColumn.createdAt,
    createdBy: varchar().references(() => usersTable.id, {
      onDelete: 'set null',
    }),
    modifiedAt: timestampsColumn.modifiedAt,
    modifiedBy: varchar().references(() => usersTable.id, {
      onDelete: 'set null',
    }),
  },
  (table) => [index('workspace_name_index').on(table.name.desc()), index('workspace_created_at_index').on(table.createdAt.desc())],
);

export type WorkspaceModel = typeof workspacesTable.$inferSelect;
export type InsertWorkspaceModel = typeof workspacesTable.$inferInsert;
